/**
 * Notificación ligera de actividad del usuario (clics, teclas, etc.).
 * SessionInactivityBanner se suscribe y reinicia avisos + cierre por inactividad.
 * Útil cuando una vista quiere marcar actividad sin depender solo de listeners globales.
 */
const listeners = new Set();

export function subscribeUserActivity(handler) {
  if (typeof handler !== 'function') return () => {};
  listeners.add(handler);
  return () => {
    listeners.delete(handler);
  };
}

export function notifyUserActivity() {
  listeners.forEach((fn) => {
    try {
      fn();
    } catch (_) {
      /* noop */
    }
  });
}

/** Alias usado en muchas vistas: notifica actividad al hub de sesión (avisos + cierre por inactividad). */
export function resetInactivityTimer() {
  notifyUserActivity();
}
